// @flow
export const RADIO_THEME_API = {
  root: '',
  disabled: '',
  input: '',
  circle: '',
  selected: '',
  label: ''
};
